import { Grid, InputAdornment } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Form } from "../../../../components/form";
import { FormButton } from "../../../../components/form_button";
import { SelectInput } from "../../../../components/select_input";
import { TextInput } from "../../../../components/text_input";
import { IAsyncData, IFormProps } from "../../../../core/models";
import { isPending } from "../../../../core/redux";
import { IAppReduxState } from "../../../../redux/store";
import { IClient } from "../../../client/data/entities";
import { clientRedux } from "../../../client/ui/state/state";
import { basicTransactionFormValidation, IBasicTransactionForm } from "../../data/basic_transaction_entity";
import { basicTransactionTypeOptions, ETransactionType, ITransactionType } from "../../data/models";

interface IProps extends IFormProps<IBasicTransactionForm> {}

export const BasicTransactionForm: React.FC<IProps> = (props: IProps) => {
  const { branch, submitTitle } = props;
  const loading = isPending(branch);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clientRedux.actions.getList());
  }, [dispatch]);
  const clientListBranch = useSelector<IAppReduxState, IAsyncData<IClient[]>>((state) => state.client.list);

  return (
    <Grid container justify="center">
      <Grid item md={8} lg={6}>
        <Form<IBasicTransactionForm>
          {...props}
          initialValues={{
            clientId: "",
            amount: 0,
            type: ETransactionType.GIVE,
          }}
          validationSchema={basicTransactionFormValidation}
        >
          {({ values }) => {
            return (
              <>
                <SelectInput<IClient>
                  value={values.clientId}
                  options={clientListBranch}
                  name="clientId"
                  label="Klient"
                  renderLabel={(a) => a.name}
                />

                <SelectInput<ITransactionType>
                  value={values.type}
                  options={basicTransactionTypeOptions}
                  name="type"
                  label="Tipi"
                  renderLabel={(a) => a.label}
                />

                <TextInput
                  label="Məbləğ"
                  name="amount"
                  type="number"
                  InputProps={{
                    startAdornment: <InputAdornment position="start">AZN</InputAdornment>,
                  }}
                />

                <FormButton label={submitTitle} loading={loading} />
              </>
            );
          }}
        </Form>
      </Grid>
    </Grid>
  );
};
